import React, { memo } from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import List from 'components/Common/List/List'

interface Props {
  roomType: App.PackageRoomType;
}

function LePackageUpgradeCardRoomDetails({ roomType }: Props) {
  return (
    <Group direction="vertical" gap={12}>
      <BodyText variant="small" weight="bold">About The Room</BodyText>
      {roomType.description &&
        <BodyText variant="small">{roomType.description}</BodyText>
      }
      {!!roomType.amenities?.length && (
        <Group direction="vertical" gap={12}>
          <BodyText variant="small" weight="bold">Room Facilities</BodyText>
          <List>
            {roomType.amenities.map(amenity =>
              <BodyText key={amenity.id} as="li" variant="small">{amenity.description}</BodyText>,
            )}
          </List>
        </Group>
      )}
    </Group>
  )
}

export default memo(LePackageUpgradeCardRoomDetails)
